import { Component, OnInit } from '@angular/core';
import { Location } from '../../model/location';
import { ToastrService } from 'ngx-toastr';
import { ColDef, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { BfsService } from '../../services/bfs.service';

@Component({
  selector: 'transfer-points',
  templateUrl: './transfer-points.component.html',
  styleUrls: ['./transfer-points.component.css']
})
export class TransferPointsComponent implements OnInit {
  fetchingData = true;
  airport: string;
  public transfers: Location[];
  rowData: any;
  headerHeight = 32;

  columnDefs: ColDef[] = [
    {
      field: "id", editable: false, hide: true
    },
    {
      headerName: 'Transfer', field: "name", editable: false
    },
    {
      headerName: 'Beskrivning', field: "description",
      editable: true,
      valueGetter: params => {
        return params.data.description;
      },
      valueSetter: params => {
        let isValid = this.validateAllowedChars(params);
        params.data.description = this.setValue(params, isValid);
        return isValid ? true : false;
      }
    },
    {
      headerName: 'Vardag Start', field: "weekdayOpens",
      editable: true,
      valueGetter: params => {
        return params.data.weekdayOpens;
      },
      valueSetter: params => {
        let isValid = this.validateTimeFormat(params);
        params.data.weekdayOpens = this.setValue(params, isValid);
        return isValid ? true : false;
      }
    },
    {
      headerName: 'Vardag Slut', field: "weekdayCloses",
      editable: true,
      valueGetter: params => {
        return params.data.weekdayCloses;
      },
      valueSetter: params => {
        let isValid = this.validateTimeFormat(params);
        params.data.weekdayCloses = this.setValue(params, isValid);
        return isValid ? true : false;
      }
    },
    {
      headerName: 'Helg Start', field: "weekendOpens",
      editable: true,
      valueGetter: params => {
        return params.data.weekendOpens;
      },
      valueSetter: params => {
        let isValid = this.validateTimeFormat(params);
        params.data.weekendOpens = this.setValue(params, isValid);
        return isValid ? true : false;
      }
    },
    {
      headerName: 'Helg Slut', field: "weekendCloses",
      editable: true,
      valueGetter: params => {
        return params.data.weekendCloses;
      },
      valueSetter: params => {
        let isValid = this.validateTimeFormat(params);
        params.data.weekendCloses = this.setValue(params, isValid);
        return isValid ? true : false;
      }
    }
  ];


  public gridOptions: GridOptions = {
    headerHeight: 32,
    animateRows: true,
    singleClickEdit: false,
    enableCellChangeFlash: false,
    columnDefs: this.columnDefs,
    // Event handlers
    onGridReady: (event: GridReadyEvent) => this.onGridReady(event)
    
  }
  constructor(private bfsService: BfsService, private toastr: ToastrService) {
  }

  validateTimeFormat(params: any) {
    if (params.oldvalue !== params.newValue) {
      let regex = new RegExp('^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$');
      let isValid = regex.test(params.newValue);
      return isValid;
    }
    return false;
  }

  validateAllowedChars(params: any) {
    if (params.oldvalue !== params.newValue) {
      let regex = new RegExp('^[a-zA-Z0-9-.,Å-ÖØ-öø-ÿ]+( +[a-zA-Z0-9-?!.,Å-ÖØ-öø-ÿ\.,]+)*$');
      let isValid = regex.test(params.newValue);
      return isValid;
    }
    return false;
  }

  setValue(params: any, isValid: boolean) {
    return isValid ? params.newValue : params.oldValue;
  }

  ngOnInit(): void {
    this.rowData = [];
    this.airport = 'ARN';
    this.loadData();

  }

  saveChanges() {
    let list = [] as Location[];
    this.rowData.forEach(r => {
      this.transfers.forEach(t => {
        if (t.id === r.id) {
          if (t.description !== r.description ||
            t.weekDayOpens !== r.weekdayOpens ||
            t.weekDayCloses !== r.weekdayCloses ||
            t.weekEndOpens !== r.weekendOpens ||
            t.weekEndCloses !== r.weekendCloses) {
            t.description = r.description;
            t.weekDayOpens = r.weekdayOpens;
            t.weekDayCloses = r.weekdayCloses;
            t.weekEndOpens = r.weekendOpens;
            t.weekEndCloses = r.weekendCloses;
            list.push(t);
          }
        }
      });
    });
    if (list.length !== 0) {
      this.bfsService.updateTransfer(list).then(res => {
        list.forEach(t => {
          this.toastr.success(`Transfer ${t.name} har blivit ändrad`, 'Uppdatering');
        });
      }).catch(res => {
        this.toastr.error(`Något gick fel när transfer uppdaterades`, 'Fel');
      });
    }
  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }

  loadData() {
    this.fetchingData = true;
    this.bfsService.getAllTransfers(this.airport)
      .then(result => {
        let list = [];
        this.transfers = result as Location[];
        this.transfers.forEach(r => {
          list.push({ id: r.id, name: r.name, description: r.description, weekdayOpens: r.weekDayOpens, weekdayCloses: r.weekDayCloses, weekendOpens: r.weekEndOpens, weekendCloses: r.weekEndCloses });
        });
        this.rowData = list;
        this.fetchingData = false;
        return;
      }, error => {
        this.fetchingData = false;
        console.log(error);
        return;
      });
  }

}


